import { normalizeTags } from './tags';

/**
 * Patch an employee in list + detail caches from a tags-assign response.
 * Avoids a list refetch just to update chips.
 */
export function patchEmployeeInCache(queryClient, companyId, employee) {
  if (!queryClient || !companyId || employee?.id == null) return;

  const tags = normalizeTags(employee.tags);
  const patched = { ...employee, tags };

  const apply = (row) =>
    String(row?.id) === String(employee.id) ? { ...row, ...patched } : row;

  queryClient.setQueriesData(
    { queryKey: ['companyEmployees', companyId] },
    (old) => {
      if (!old) return old;
      if (Array.isArray(old)) return old.map(apply);
      if (Array.isArray(old.results)) {
        return { ...old, results: old.results.map(apply) };
      }
      return old;
    },
  );

  queryClient.setQueriesData(
    { queryKey: ['employeeDetails', companyId] },
    (old) => {
      if (!old || String(old.id) !== String(employee.id)) return old;
      return { ...old, ...patched };
    },
  );
}
